import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Shipment } from "../../models/api/shipment";
import { ApiService } from "../../services/api.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Component({
  selector: "app-result",
  templateUrl: "./result.component.html",
  styleUrls: ["./result.component.scss"],
})
export class ResultComponent implements OnInit {
  mapFrameUrl: SafeHtml;

  shipment: Shipment = new Shipment();
  isLoading = true;
  constructor(
    private sanitizer: DomSanitizer,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      let id: string = params["id"];
      if (id && id != "") {
        this.apiService.getShipment(id).subscribe(
          (value) => {
            this.isLoading = false;
            this.shipment = value;

            // Move this inside the subscribe block:
            if (this.shipment && this.shipment.vessel) {
              this.mapFrameUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                this.shipment.vessel
              );
            }
          },
          (err: HttpErrorResponse) => {
            this.router.navigate(["/404"]);
          }
        );
      } else {
        this.router.navigate(["/404"]);
      }
    });
  }
}
